import ErrorPage from '~/components/ErrorPage';
import { closeCurrentModal } from '~/utils/mobileApp';

export function NoEvent() {
  return (
    <ErrorPage
      onResetClick={closeCurrentModal}
      title="현재 진행중인 이벤트가 없습니다."
      description="잠시 후 다시 시도해주세요."
      resetText="캐시노트 홈으로 이동"
    />
  );
}
